import type { Category } from "../hooks/useCategories.ts";
import { navigate } from "../lib/router.ts";
import { formatNumber } from "../lib/format.ts";

export function CategoryCard({ category }: { category: Category }) {
  return (
    <a
      href={`/category/${category.slug}`}
      onClick={(e) => { e.preventDefault(); navigate(`/category/${category.slug}`); }}
      className="group block border border-border px-4 py-3 hover:bg-surface-hover hover:border-border-hover transition-all"
    >
      <div className="flex items-center justify-between mb-1">
        <span className="text-sm text-text-primary group-hover:text-accent transition-colors font-medium">
          {category.name}
        </span>
        <span className="text-[10px] text-text-muted tabular-nums">
          {formatNumber(category.project_count)}
        </span>
      </div>
      <p className="text-xs text-text-muted line-clamp-2">{category.description}</p>
    </a>
  );
}
